import { Fragrance } from "./v1";

export const fragranceOptions = Object.entries(Fragrance)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
